// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flexRow_flex__3E6wH {\n  display: flex;\n  align-items: center;\n}", ""]);
// Exports
exports.locals = {
	"flex": "flexRow_flex__3E6wH"
};
module.exports = exports;
